import { Price } from "../../misc/price";

interface Product {
  readonly price: Price;
  readonly cancelled?: object;
}

export function getTotalPrice(products: Product[]): Price {
  return products
    .filter((p) => !p.cancelled)
    .map((p) => p.price)
    .reduce((prev, curr) => prev.add(curr), new Price(0));
}
